import { render, staticRenderFns } from "./InvestorContent.vue?vue&type=template&id=0b66add2&scoped=true"
import script from "./InvestorContent.vue?vue&type=script&lang=js"
export * from "./InvestorContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66add2",
  null
  
)

export default component.exports